import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AvatarCreator } from '@readyplayerme/react-avatar-creator';
import './AvatarCustomization.css';

export default function AvatarCustomization() {
  const navigate = useNavigate();
  const hasSaved = useRef(false);
  const subdomain = "elevator-pitch";

  const config = {
    clearCache: true,
    bodyType: 'fullbody',
    quickStart: true,
    language: 'en',
  };

  // 🌌 Star background generator
  useEffect(() => {
    const container = document.querySelector('.space-bg');
    if (!container) return;

    const stars = Array.from({ length: 100 }, () => {
      const star = document.createElement('div');
      star.className = 'star';
      star.style.top = `${Math.random() * 100}vh`;
      star.style.left = `${Math.random() * 100}vw`;
      container.appendChild(star);
      return star;
    });

    return () => stars.forEach((star) => container.removeChild(star));
  }, []);

  // 🧼 Clean up iframe on unmount
  useEffect(() => {
    return () => {
      const iframe = document.querySelector('iframe');
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
        console.log("🧼 Iframe removed from DOM.");
      }
    };
  }, []);

  const handleAvatarExport = async (event) => {
    const avatarUrl = event.data.url;
    if (!avatarUrl || hasSaved.current) return;
    hasSaved.current = true;

    console.log('✅ Avatar exported:', avatarUrl);

    try {
      // ⬇️ Step 1: Fetch blob from Ready Player Me
      const response = await fetch(avatarUrl);
      const blob = await response.blob();
      const file = new File([blob], "avatar.glb", { type: "model/gltf-binary" });

      // ⬆️ Step 2: Upload to backend (S3)
      const formData = new FormData();
      formData.append("file", file);

      const uploadRes = await fetch(`${process.env.REACT_APP_API_URL}/avatar/upload`, {
        method: "POST",
        headers: new Headers({
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }),
        body: formData,
      });


      if (!uploadRes.ok) throw new Error("❌ Upload failed");

      const { avatarUrl: publicAvatarUrl } = await uploadRes.json();
      console.log("☁️ Uploaded to S3:", publicAvatarUrl);

      // 💾 Step 3: Save public URL to backend
      const saveRes = await fetch(`${process.env.REACT_APP_API_URL}/avatar/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ avatarUrl: publicAvatarUrl }),
      });

      const saveData = await saveRes.json();
      if (!saveData.success) throw new Error("❌ Save to user profile failed");

      console.log("✅ Avatar saved to user profile.");

      // ✅ Step 4: Go to staging screen
      navigate('/avatar-staging', {
        state: { avatarUrl: publicAvatarUrl },
      });

    } catch (error) {
      console.error("🚨 Avatar upload or save failed:", error);
      alert("Something went wrong. Please try again.");
      hasSaved.current = false;
    }
  };

  return (
    <div className="AvatarCustomization">
      <div className="space-bg"></div>
      <h2>Customize Your Avatar</h2>
      <p>Design your 3D avatar with Ready Player Me.</p>

      <div
        className="iframe-wrapper"
        style={{ zIndex: 3, position: 'relative' }}
      >
        <AvatarCreator
          subdomain={subdomain}
          onAvatarExported={handleAvatarExport}
          config={config}
          style={{ width: '100%', height: '600px', border: 'none' }}
        />
      </div>
    </div>
  );
}
